import React from 'react';
import cx from 'classnames';
import Styles from './index.module.scss';

export interface ICommonHeaderM {
  className?: string;
  title?: React.ReactElement;
  renderLeft?: () => React.ReactElement;
  renderExtra?: () => React.ReactElement[];
}

const CommonHeaderM = ({
  title,
  className = '',
  renderLeft = () => <React.Fragment />,
  renderExtra = () => [],
}: ICommonHeaderM) => {
  return (
    <div className={cx(Styles.root, className)}>
      { renderLeft() }
      {title && <div className={Styles.title}>{ title }</div>}
      <div className={Styles.actions}>
        { renderExtra() }
      </div>
    </div>
  );
};

export default CommonHeaderM;
